import { AuthProvider } from '@40seas/entities/auth';
import { SetupModal } from '@40seas/frontend/libs/entities';
import { datadogRumProvider } from '@40seas/frontend/libs/providers';
import { CreatePathParams } from 'react-admin';

export const navigationProvider = {
    navigationToDashboard: (options?: { slug: string; token: string; authProvider?: AuthProvider }) => {
        const setup = (window as any).__SETUP__ as SetupModal;

        datadogRumProvider.setGlobalContext('redirect', setup.urls.DASHBOARD_URL);

        const tokenParam = options?.token ? `?t=${options.token}` : '';
        const authParam = options?.authProvider === AuthProvider.SelfManaged ? `${tokenParam ? '&' : '?'}auth=self-managed` : '';
        const urlToRedirect = `${setup.urls.DASHBOARD_URL}${options?.slug ? `/${options.slug}/login` : ''}${tokenParam}${authParam}`;

        window.location.href = urlToRedirect;
    },

    navigateToDashboardForNewSupplier: (options?: { slug: string; token: string }) => {
        const setup = (window as any).__SETUP__ as SetupModal;

        datadogRumProvider.setGlobalContext('redirect', setup.urls.DASHBOARD_URL);

        const slugPath = options?.slug ? `/${options.slug}` : '';
        const tokenParam = options?.token ? `?t=${options.token}` : '';
        const urlToRedirect = `${setup.urls.DASHBOARD_URL}${slugPath}/account${tokenParam}#getStarted`;

        window.location.href = urlToRedirect;
    },
    // the logic is similar to the useCreatePath
    navigateToPath: ({ resource, id, type, slug }: CreatePathParams & { slug?: string }): void => {
        const setup = (window as any).__SETUP__ as SetupModal;

        const baseUrl = setup.urls.DASHBOARD_URL ?? '';
        const basename = slug ? `${baseUrl}/${slug}` : baseUrl;
        const joinUrl = (base: string, ...paths: Array<string | undefined>) => {
            const trimmedBase = base.replace(/\/+$/, '');
            const cleaned = paths
                .filter((segment): segment is string => Boolean(segment))
                .map((segment) => segment.replace(/^\/+|\/+$/g, ''))
                .join('/');
            return cleaned ? `${trimmedBase}/${cleaned}` : trimmedBase;
        };

        let url = '';
        switch (type) {
            case 'list':
                url = joinUrl(basename, resource);
                break;
            case 'create':
                url = joinUrl(basename, resource, 'create');
                break;
            case 'edit': {
                if (id == null) {
                    // maybe the id isn't defined yet
                    // instead of throwing an error, fallback to list link
                    url = joinUrl(basename, resource);
                } else {
                    url = joinUrl(basename, resource, encodeURIComponent(String(id)));
                }
                break;
            }
            case 'show': {
                if (id == null) {
                    // maybe the id isn't defined yet
                    // instead of throwing an error, fallback to list link
                    url = joinUrl(basename, resource);
                    break;
                }
                url = joinUrl(basename, resource, encodeURIComponent(String(id)), 'show');
                break;
            }
            default:
                url = type;
        }
        window.location.href = url;
    },
    isGoToDashboardNeeded: (intent: { isInternal?: boolean; isEmbedded?: boolean }): boolean => {
        if (intent?.isInternal) {
            return false;
        }
        return !intent?.isEmbedded;
    },
    getUTMParams: () => {
        const searchParams = new URLSearchParams(window.location.search);
        const utmParams: Record<string, string> = {};

        searchParams.forEach((value, key) => {
            if (key.startsWith('utm_')) {
                utmParams[key] = value;
            }
        });

        return utmParams;
    },
};
